export default __webpack_public_path__ + "static/media/nbmon2.881ab336.png";